// Test accounts and their sessions stay out of Discover, Sounds, the
// session lists and People search (SI-18), as the app hides them
// (lib/models/test_accounts.dart). Case-insensitive.

export const TEST_USER = /^(dummy\d*|moneypath.*|datamancer.*|cltest[-_].*|(capture|smoke|loopuser)\d{6,})$/i;
export const TEST_SESSION = /^(moneypath|smoke|capture)[-_]/i;

export function isTestAccount(username) {
  const u = typeof username === "string" ? username.trim() : "";
  return !!u && TEST_USER.test(u);
}

// Someone the invite picker may offer (plan W4's Invite): never you, never
// a test account, even one you follow. SI-18's "people you follow stay" is
// People's Following list only.
export function invitable(username, me = null) {
  const u = typeof username === "string" ? username.trim() : "";
  return !!u && u !== me && !isTestAccount(u);
}

// A session is hidden when its name looks like a test run, or a test
// account made it.
export function isTestSession(row) {
  if (!row) return false;
  const name = typeof row.name === "string" ? row.name.trim() : "";
  return (!!name && TEST_SESSION.test(name)) || isTestAccount(row.creator);
}
